import stringUtils from '../../utils/string';

function _isObject(ele) {
  return ele !== null && typeof ele === 'object'; // && !(ele instanceof Array);
}

function _each(obj, callback) {
  let i;
  if (!callback) {
    return null;
  }
  if (obj instanceof Array) {
    for (i = 0; i < obj.length; i += 1) {
      if (callback(i, obj[i]) === false) {
        break;
      }
    }
  } else if (obj instanceof Object) {
    Object.keys(obj).forEach(key => {
      callback(key, obj[key]);
    });
  }
  return null;
}

function _mapObj(mapping, obj) {
  if (!_isObject(mapping) && !_isObject(obj)) {
    throw new Error('Invalid Parameters'); // todo give proper message
  }
  const newObj = {};
  _each(mapping, (k, v) => {
    if (typeof v === 'function') {
      newObj[k] = v(obj);
    } else {
      newObj[k] = obj[v];
    }
  });
  return newObj;
}

const User = function User(attr) {
  const prvt = {};
  let finalAttr = attr;
  const tthis = this;
  const mapping = {
    uid: 'ssoid', // ssoid
    email: 'primaryEmail', // map primaryEmail
    id: 'ssoid', // ssoid
    name: 'firstName', // firstname
    firstName: 'firstName', // firstname
    lastName: 'lastName', // lastname
    icon: 'profileImageUrl', // profileimageurl
    CITY: 'city', // city
    thumb: 'thumbImageUrl', // thumbURL
    mobile: 'mobileData',
    ticketId: 'ticketId',
  };

  if (mapping && _isObject(mapping)) {
    finalAttr = _mapObj(mapping, attr);
  }
  _each(finalAttr, (k, v) => {
    prvt[k] = v;
    const kCamelCase = stringUtils.camelCase(k);
    tthis[`get${kCamelCase}`] = () => prvt[k];
  });

  this.getMappedUser = function getMappedUser() {
    return prvt; // todo return clone.
  };
  this.getOriginalUser = function getOriginalUser() {
    return finalAttr; // todo return clone.
  };
  this.toString = function toString() {
    return JSON.stringify(prvt, true, '\t');
  };
  this.toJson = this.toString;
};

export function getNewUser(defaultUser) {
  if (defaultUser instanceof User) {
    return defaultUser;
  } else if (_isObject(defaultUser)) {
    return new User(defaultUser);
  }
  return null;
}

export function isUser(obj) {
  return obj instanceof User;
}
